import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "video-full"
};
const _hoisted_2 = ["src"];
import PageLoading from "@/components/PageLoading/index";
import { watch } from "vue";

import { ref } from 'vue';
export default {
  __name: 'index',
  props: ["src"],
  setup(__props) {
    const props = __props;
    const loading = ref(true);
    const onVideoLoad = () => {
      loading.value = false;
    };
    watch(() => props.src, () => {
      loading.value = true;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createVNode(_unref(PageLoading), null, null, 512), [[_vShow, _unref(loading)]]), _createElementVNode("video", {
        style: {
          "width": "100%",
          "height": "100%"
        },
        autoplay: "",
        src: __props.src,
        onLoadeddata: onVideoLoad
      }, null, 40, _hoisted_2)]);
    };
  }
};